/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";
import { Spacer, Text } from "@nordcloud/gnui";
import styles from "~/assets/styles/Runbook.module.css";
import { Divider } from "~/components/Styled/Divider";
import { Application } from "~/models";

type Props = {
  application: Application;
};

function CloudAccounts({ application }: Props) {
  return (
    <Divider css={{ width: "500px" }}>
      <Spacer height="1rem" />
      <Text isTitle weight="medium">
        Cloud Accounts
      </Text>

      {application?.cloudAccounts?.length < 1 ? (
        <Text mt={3}>No Cloud Accounts</Text>
      ) : (
        <>
          <div className={styles.columnsContainer}>
            <span className={styles.tableHeader}>Cloud Provider</span>
            <span className={styles.tableHeader}>Account ID</span>
            <span className={styles.tableHeader}>Account name</span>
          </div>

          {application?.cloudAccounts?.map((ca, index) => (
            <div key={index} className={styles.columnsContainer}>
              <p className={styles.tableElement}>{ca?.cloudProvider}</p>
              <p className={styles.tableElement}>{ca?.accountId}</p>
              <p className={styles.tableElement}>{ca?.accountName}</p>
            </div>
          ))}
        </>
      )}
      <Spacer height="1rem" />
    </Divider>
  );
}

export { CloudAccounts };
